<template>
  <div v-if="html" class="markdown-body" v-html="html" />
  <p v-else class="markdown-empty">{{ emptyText }}</p>
</template>

<script>
import { computed } from 'vue'
import { renderExamMarkdown } from '@/utils/markdown'

export default {
  name: 'MarkdownBody',
  props: {
    content: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const html = computed(() => renderExamMarkdown(props.content))
    return { html }
  }
}
</script>

<style scoped>
.markdown-empty {
  margin: 0;
  color: var(--el-text-color-placeholder);
}

.markdown-body {
  font-size: 16px;
  line-height: 1.8;
  color: var(--el-text-color-regular);
  word-break: break-word;
}

:deep(.markdown-body h1),
:deep(.markdown-body h2),
:deep(.markdown-body h3),
:deep(.markdown-body h4) {
  margin: 1.2em 0 0.6em;
  line-height: 1.4;
  color: var(--el-text-color-primary);
  font-weight: 600;
}

:deep(.markdown-body h1) {
  font-size: 1.5em;
}
:deep(.markdown-body h2) {
  font-size: 1.35em;
}
:deep(.markdown-body h3) {
  font-size: 1.2em;
}
:deep(.markdown-body h4) {
  font-size: 1.1em;
}

:deep(.markdown-body p) {
  margin: 0 0 1em;
}

:deep(.markdown-body ul),
:deep(.markdown-body ol) {
  margin: 0 0 1em;
  padding-left: 1.5em;
}

:deep(.markdown-body li) {
  margin: 0.25em 0;
}

:deep(.markdown-body strong) {
  font-weight: 600;
  color: var(--el-text-color-primary);
}

:deep(.markdown-body em) {
  font-style: italic;
}

:deep(.markdown-body hr) {
  border: none;
  border-top: 1px solid var(--el-border-color);
  margin: 1.5em 0;
}

:deep(.markdown-body a) {
  color: var(--el-color-primary);
  text-decoration: none;
}

:deep(.markdown-body a:hover) {
  text-decoration: underline;
}

:deep(.markdown-body pre) {
  overflow: auto;
  padding: 12px;
  border-radius: 6px;
  background: var(--el-fill-color-light);
  margin-bottom: 1em;
}

:deep(.markdown-body code) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.9em;
}

:deep(.markdown-body :not(pre) > code) {
  padding: 0.15em 0.35em;
  border-radius: 4px;
  background: var(--el-fill-color-light);
}

:deep(.markdown-body blockquote) {
  margin: 0 0 1em;
  padding: 0 1em;
  color: var(--el-text-color-secondary);
  border-left: 4px solid var(--el-border-color);
}

:deep(.markdown-body table) {
  display: block;
  width: 100%;
  overflow: auto;
  margin: 0 0 16px;
  border-spacing: 0;
  border-collapse: collapse;
}

:deep(.markdown-body table th),
:deep(.markdown-body table td) {
  padding: 8px 13px;
  border: 1px solid var(--el-border-color);
}

:deep(.markdown-body table th) {
  background-color: var(--el-fill-color-light);
  font-weight: 600;
}

:deep(.markdown-body table tr:nth-child(2n)) {
  background-color: var(--el-fill-color-lighter);
}
</style>
